<template>
  <div>
    <v-card flat>
      <v-card-title v-if="isApp">
        <v-spacer />
        <v-btn
          :loading="loading"
          class="rounded-lg btn-accept"
          depressed
          @click="submitContacts"
        >
          <v-icon left>mdi-account-box</v-icon>
          ذخیره مخاطبین
        </v-btn>
      </v-card-title>
    </v-card>

    <v-card
      :min-height="!hasPermission ? '50vh' : ''"
      class="d-flex flex-column justify-center align-center"
      flat
    >
      <!--      <v-card-subtitle v-if="!isApp">-->
      <!--        لطفا برای ایجاد دسترسی و ذخیره مخاطبین وارد اپلیکیشن اندروید شوید.-->
      <!--      </v-card-subtitle>-->

      <div v-if="loading" class="text-center" translate="no">
        <v-progress-circular
          class="mx-auto"
          indeterminate
          size="50"
          width="5"
        />
        <v-card-title>درحال بررسی...</v-card-title>
      </div>

      <div v-else class="flex w-100 text-right pa-4">
        <div class="mb-4">
          <v-card class="mb-12" flat>
            <div class="d-flex align-center">
              <v-btn class="btn-edit" depressed @click="dialog = true">
                <v-icon left>mdi-clipboard-list-outline</v-icon>
                تغییر پترن/کمپین
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="
                  defaultStored != null &&
                  !!selectedRow &&
                  !!selectedRow.length &&
                  defaultStored !== selectedRow[0].id
                "
                color="red"
                text
                @click="getDefaultPattern"
              >
                لغو
                <v-icon right>mdi-close-circle-outline</v-icon>
              </v-btn>
            </div>

            <template v-if="selectedRow && selectedRow.length">
              <p class="px-4 pt-4 font-size-h4">
                {{
                  Object.hasOwn(selectedRow[0], "messages") ? "کمپین" : "پترن"
                }}
                انتخاب شده:
                {{ selectedRow[0].id }}
              </p>

              <div
                v-if="!Object.hasOwn(selectedRow[0], 'messages')"
                class="pa-4 grey lighten-2 rounded-lg fit-content font-size-h6"
                style="width: fit-content"
              >
                <pre v-html="selectedRow[0].content" />
              </div>

              <div
                v-else-if="
                  selectedRow[0].messages && selectedRow[0].messages.text
                "
                class="d-flex flex-wrap"
              >
                <div
                  v-for="(item, i) in selectedRow[0].messages.text"
                  :key="i"
                  class="ma-2 pa-4 grey lighten-2 rounded-lg fit-content font-size-h6"
                  style="width: fit-content"
                >
                  <v-avatar
                    class="mt-n12 ms-n6 white--text pa-2"
                    color="success"
                    size="24"
                    >{{ i + 1 }}</v-avatar
                  >
                  <pre class="mt-n6 ma-0" v-html="item" />
                </div>
              </div>
            </template>
          </v-card>
        </div>

        <contact-list-setting ref="settings" />

        <v-card-actions class="justify-end">
          <v-btn
            :loading="patternLoading"
            color="btn-accept"
            depressed
            width="120"
            @click="setDefault"
          >
            <v-icon left>mdi-content-save-cog-outline</v-icon>
            ثبت
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>

    <save-steps v-model="dialog" :selected.sync="selectedRow" />
  </div>
</template>

<script>
import SuggestInput from "@/view/content/sms/suggestInput/suggestInput.vue";
import ContactListSetting from "@/view/pages/contacts/contactListSetting.vue";
import SaveSteps from "@/view/pages/contacts/saveSteps.vue";

export default {
  name: "sendContacts",

  components: { SaveSteps, ContactListSetting, SuggestInput },

  data() {
    return {
      loading: false,
      dialog: false,
      callLoading: false,
      patternHeaders: [],
      patternData: [],
      selectedRow: [],
      defaultStored: null,
      submitNewPattern: false,
      patternProps: {
        length: 10,
        page: 1,
        dir: "desc",
        type: "normal",
        status: "private",
        active: 1,
        default: 1,
      },
      patternLoading: false,
      // RemoveMe: clear comments
      // patternCons: {
      //   title: 'انتخاب پترن/کمپین',
      //   // buttons: [
      //   //   {type: 'submit', handler: this.setDefault, disabled: () => this.disableConfirm}
      //   // ]
      // },
      patternTitle: "",
      patternText: "\nلغو11",
      rules: {
        text: [
          (n) => !!n || this.$t("ERRORS.EmptyText"),
          (n) => n.includes("لغو11") || "متن بایستی شامل عبارت لغو11 باشد",
        ],
        empty: [(n) => (!!n && n.length > 2) || "فیلد نمی‌تواند خالی باشد."],
        line: [(n) => !!n || this.$t("ERRORS.NoSelectedLineNumber")],
        link: [(n) => this.isDomain(n) || "لینک صحیح وارد نمایید"],
      },
    };
  },

  mounted() {
    this.getDefaultPattern();
  },

  computed: {
    isApp() {
      return !!localStorage.getItem("isMobile");
    },
    hasPermission() {
      return !!localStorage.getItem("hasPermissions");
    },
    // disableList() {
    //   return this.e6 > 1 || this.callLoading
    // },
    // disableConfirm() {
    //   return !this.selectedRow || !this.selectedRow?.length
    // },
    campHref() {
      const token = localStorage.getItem("id_token");
      return `${this.$corepayamakApi}/?token=${token}/#/campaign`;
    },
    canMore() {
      return (
        !!this.patternText.replace("\nلغو11", "") &&
        this.patternText.includes("لغو11")
      );
    },
  },

  methods: {
    getDefaultPattern() {
      this.loading = true;

      this.requestApiGetPayamak("text/get/default")
        .then(({ data }) => {
          this.defaultStored = data.data?.id;
          this.selectedRow = [data.data];
        })
        .catch(({ response }) => {
          // this.$toast.error('خطا در دریافت پترن/کمپین پیشفرض')
          console.log("failed to get default pattern: ", response);
        })
        .finally(() => (this.loading = false));
    },
    submitContacts() {
      if (!this.hasPermission)
        return this.$toast.error(
          "لطفا ابتدا دسترسی مخاطبین را برای ذخیره در لیست،فعال نمایید.",
          { timeout: 5000 }
        );

      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
      console.log("store_contacts");
      this.$toast.info("درخواست ذخیره مخاطبین با موفقیت ارسال شد.", {
        timeout: 5000,
      });
    },
    setDefault(close = true) {
      this.patternLoading = true;

      try {
        this.$refs.settings.saveSettings();
      } catch (e) {
        console.log(e);
      }

      if (!this.selectedRow?.length) {
        setTimeout(() => {
          this.patternLoading = false;
        }, 1000);
        return;
      }

      this.requestApiPostPayamak("text/set/default", {
        type: Object.hasOwn(this.selectedRow[0], "messages")
          ? "campaign"
          : "pattern",
        item_id: this.selectedRow[0].id,
      })
        .then(({ data }) => {
          this.dialog = false;
          if (!close) {
            this.$toast.success("با موفقیت تنظیم شد.");
            this.$emit("reload");
          }
        })
        .finally(() => (this.patternLoading = false));
    },
    sateText(state) {
      switch (state) {
        case "accept":
          return {
            text: "تایید شده",
            color: "success",
          };
        case "pending":
          return {
            text: "منتظر تایید",
            color: "warning",
          };
        case "reject":
          return {
            text: "رد شده",
            color: "red",
          };
      }
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      // var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");

      return !str || regex.test(str) || str.length <= 0;
    },
    // submit() {
    //   this.patternLoading = true
    //
    //   axios.post('https://sms-api.terminalads.com/api/text/create', {
    //     content: this.patternText,
    //     title: this.patternTitle,
    //     desc: this.patternTitle,
    //     phone_id: 59,
    //     type: "normal"
    //   })
    //     .then(({data}) => {
    //       this.patternTabs = 0
    //       this.submitNewPattern = false
    //
    //       this.$nextTick(() => {
    //         this.getPatternList()
    //       })
    //     })
    //     .finally(() => this.patternLoading = false)
    // }
  },
};
</script>

<style>
pre {
  font-family: "vazir", serif !important;
}
</style>
